export default __webpack_public_path__ + "static/media/clock green.f218dd5c.svg";